import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Icon, { GLYPHS } from '../../../../../common/icon';
import Modal from '../../../../../common/Modal';
import BarberAvatar from '../../../../barbers/components/BarberAvatar';

const NotifyBarbersModal = ({
  onClose,
  onNotifyClicked,
  barbersWithIssues,
}) => (
  <Modal
    close={onClose}
    className="c-modal-new c-notify-barbers-bank-accounts-modal"
    showCloseButton
  >
    <div
      className="o-flexbox o-flexbox--content-align-center o-flexbox--column u-p+"
    >
      <Icon glyph={GLYPHS.email2} size="large" className="c-modal-new__header-icon" />
      <div className="c-modal-new__header">
        Notify barbers
      </div>
      <p className="c-modal-new__text u-mb">
        Send an email with instructions on how to link a bank account to the following barbers.
      </p>

      <div className="c-notify-barbers-bank-accounts--list">
        {barbersWithIssues.map((barberWithIssues, index) => (
          <Fragment key={barberWithIssues.id}>
            <div
              display-if={!barberWithIssues.hasBankAccount}
              className="u-flex u-align-items-center u-width-100 u-mv--"
            >
              <span className="c-avatar u-mr-">
                <BarberAvatar barber={barberWithIssues} />
              </span>
              <span className="u-fontsize-extrasmall u-type--semibold c-autopayout__text-black">
                {barberWithIssues.firstName} {barberWithIssues.lastName}
              </span>
              <span className="u-fontsize-extrasmall u-flex-1 u-text-right">
                {barberWithIssues.email ? 'No bank account' : 'No email on file'}
              </span>
            </div>
            <div className="c-separator u-width-100" display-if={index !== (barbersWithIssues.length - 1)} />
          </Fragment>
        ))}
      </div>

      <button
        className="c-btn c-btn--medium u-mt+ u-width-100"
        onClick={onNotifyClicked}
      >
        Send email
      </button>
    </div>
  </Modal>
);

NotifyBarbersModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onNotifyClicked: PropTypes.func.isRequired,
  barbersWithIssues: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default NotifyBarbersModal;
